export const iconFontAwesomeArrowsRecycle = (
	<i className="fa-solid fa-recycle"></i>
);
